export enum ETypes {
  User = 'User',
  Account = 'Account',
  Operation = 'Operation',
}

export enum ELimitsSearchForm {
  AccId = 'accId',
  Counterparty = 'counterparty',
}

export enum ETableRowType {
  Operation = 'Operation', // payment
  User = 'User', // amount
}
